import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  // Dark, rounded, inset banner sitting below the Policy Term row. Horizontal margin insets it from
  // the parent Card, which has no horizontal padding of its own.
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    margin: theme.spacing(0, 6),
    padding: theme.spacing(3, 4),
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colorPalette.green_100
  },
  icon: {
    width: 16,
    height: 16,
    flexShrink: 0
  },
  // Label is display:flex; block keeps the whitespace around the inline link.
  note: {
    display: 'block',
    lineHeight: 1.5
  },
  bold: {
    fontWeight: 600
  },
  // Native button styled as an inline text link (core Button renders boxy inline).
  link: {
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    color: theme.colorPalette.orange_50,
    textDecoration: 'underline'
  }
}));
